import { AxiosError } from 'axios';
import { AppExceptionResponseData } from '../../../hooks/useHandleAppException';
import LangEnum from '../../../lang/LangEnum';
import { getBrandLoginContext } from '../../../services/modules/sso/sso.repository';

const HANDOFF_HASH_PARAM = 'hc';
const ERROR_HASH_PARAM = 'error';

const SSO_CALLBACK_ERROR_LANG_BY_CODE: Partial<Record<string, LangEnum>> = {
  'api.exception.sso.userNotProvisioned': LangEnum.API_EXCEPTION_SSO_USER_NOT_PROVISIONED,
  'api.exception.sso.userWithoutBrandContext':
    LangEnum.API_EXCEPTION_SSO_USER_WITHOUT_BRAND_CONTEXT,
  'api.exception.sso.identityUserDeleted': LangEnum.API_EXCEPTION_SSO_IDENTITY_USER_DELETED,
  'api.exception.sso.identityUserInactive': LangEnum.API_EXCEPTION_SSO_IDENTITY_USER_INACTIVE,
  'api.exception.sso.brandLicensesExhausted': LangEnum.API_EXCEPTION_SSO_BRAND_LICENSES_EXHAUSTED,
  'api.exception.sso.consentDenied': LangEnum.API_EXCEPTION_SSO_CONSENT_DENIED,
  'api.exception.sso.requiredClaimMissing': LangEnum.API_EXCEPTION_SSO_REQUIRED_CLAIM_MISSING,
  'api.exception.sso.requiredClaimNotAllowed':
    LangEnum.API_EXCEPTION_SSO_REQUIRED_CLAIM_NOT_ALLOWED,
  'api.exception.sso.reauthRequired': LangEnum.API_EXCEPTION_SSO_REAUTH_REQUIRED,
  'api.exception.sso.sessionExpired': LangEnum.API_EXCEPTION_SSO_SESSION_EXPIRED,
  'api.exception.sso.stateMissing': LangEnum.SSO_CALLBACK_LINK_INVALID,
  'api.exception.sso.stateInvalid': LangEnum.SSO_CALLBACK_LINK_INVALID,
  'api.exception.sso.stateBindingInvalid': LangEnum.SSO_CALLBACK_LINK_INVALID,
};

export const extractHandoffCode = (hash: string): string | null => {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  return params.get(HANDOFF_HASH_PARAM) || null;
};

export const extractErrorCode = (hash: string): string | null => {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  return params.get(ERROR_HASH_PARAM) || null;
};

export const resolveSsoCallbackErrorLang = (code: string | null): LangEnum | null => {
  if (!code) {
    return null;
  }
  return SSO_CALLBACK_ERROR_LANG_BY_CODE[code] ?? LangEnum.SSO_CALLBACK_GENERIC_ERROR;
};

export const buildLocalException = (code: LangEnum): AppExceptionResponseData => ({
  code,
  message: '',
});

export const readAppExceptionData = (error: unknown): AppExceptionResponseData | null => {
  const exceptionData = (error as AxiosError<AppExceptionResponseData>)?.response?.data;
  return exceptionData?.code ? exceptionData : null;
};

export const resolveLoginBrandId = async (brandSlug: string): Promise<string | undefined> => {
  try {
    const response = await getBrandLoginContext(brandSlug);
    return response.ok ? response.data?.id : undefined;
  } catch {
    return undefined;
  }
};

export const clearHandoffCodeFromUrl = () => {
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
};
